import React, { useContext, useEffect, useState } from "react"
import { ActivityIndicator, View } from "react-native"
import { QuestionMultiline } from "@Components/Diagnostic/Question/QuestionMultiline"
import { QuizzContext } from "@Providers/QuizzProvider"
import { KnowledgeService } from "@Services/Knowledge/Knowledge.Service"
import { QuestionYesOrNoWithoutSteps } from "@Components/Diagnostic/Question/QuestionYesOrNoWithoutSteps"
import { QuestionWithCheckBox } from "@Components/Diagnostic/Question/QuestionWithCheckBox"
import { baseColors } from "@Constants/baseStyles"
import styles from "./styles"

export const QuestionItems = (props) => {
    const { setQuestionLength, setPayload, fetchingResponse, userResponses, isResult } = props
    const { selectedQuizz } = useContext(QuizzContext)
    const [fetching, setFetching] = useState(false)
    const [questions, setQuestions] = useState({})
    const quizId = selectedQuizz?.id

    const fetchQuestionsByQuizz = () => {
        setFetching(true)
        KnowledgeService.getQuestionsByQuizzId(quizId)
            .then((res) => {
                const data = res?.data?.data?.[0]
                setFetching(false)
                setQuestions(res?.data?.data?.[0])
                setQuestionLength(data?.questions?.length)
            })
            .catch(() => {
                setFetching(false)
            })
    }

    useEffect(() => {
        fetchQuestionsByQuizz()
    }, [quizId])

    const questionItems = questions?.questions ?? []

    if (fetching || fetchingResponse) {
        return (
            <View style={styles.loading}>
                <ActivityIndicator color={baseColors.green.primary} size={50} />
            </View>
        )
    }

    return (
        <View>
            {questionItems?.map((questionItem, i) => {
                const { questionId, textQuestion, responseType, responses } = questionItem
                const questionNumber = i + 1
                const userResponse = userResponses?.find((response) => response.questionId === questionId)

                if (responseType === "radio") {
                    return (
                        <QuestionYesOrNoWithoutSteps
                            key={questionId}
                            responses={responses}
                            questionNumber={questionNumber}
                            question={textQuestion}
                            questionId={questionId}
                            setPayload={setPayload}
                            userResponse={userResponse}
                            isResult={isResult}
                        />
                    )
                }

                if (responseType === "checkbox") {
                    return (
                        <QuestionWithCheckBox
                            key={questionId}
                            responses={responses}
                            questionNumber={questionNumber}
                            question={textQuestion}
                            questionId={questionId}
                            setPayload={setPayload}
                            isResult={isResult}
                            userResponse={userResponse}
                        />
                    )
                }

                if (responseType === "text") {
                    return (
                        <QuestionMultiline
                            key={questionId}
                            responses={responses}
                            userResponse={userResponse}
                            questionNumber={questionNumber}
                            question={textQuestion}
                            questionId={questionId}
                            setPayload={setPayload}
                            isResult={isResult}
                        />
                    )
                }
            })}
        </View>
    )
}
